import React from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';
import {
	Wrapper,
	ImageContainer,
	TextContainer,
	Title,
	Text,
	Actions,
	ScrollContainer,
} from './NoData.styles.js';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const NoData = () => {
	const history = useHistory();
	const handleNavigatetoMaster = () => {
		history.push({
			pathname: '/category-management/category-widgets',
			search: '?isMaster=true', // query string
			state: {
				// location state
				isMaster: true,
			},
		});
	};

	return (
		<ScrollContainer>
			<Wrapper>
				<ImageContainer />
				<TextContainer>
					<Title>There’s currently there are no Modules to Display</Title>
					<Text>Please create a Module in Master Sku Data</Text>
					<Actions>
						<ApButtonMain
							iconName="upload_outlined"
							onClick={() => handleNavigatetoMaster()}
						>
							Create a Module
						</ApButtonMain>
					</Actions>
				</TextContainer>
			</Wrapper>
		</ScrollContainer>
	);
};
export default NoData;
